<template>
  <ul class="progress-steps">
    <li class="item">
      <step :to="{ name: 'admin-quotation-customer', params: { quotationId } }" :step="model[0]" :first="true"/>
    </li>
    <li class="item">
      <step :to="quotationId == 'novo' ? '#' : { name: 'admin-quotation-service', params: { quotationId } }" :step="model[1]" />
    </li>
    <li class="item">
      <step :to="quotationId == 'novo' ? '#' : { name: 'admin-quotation-edit', params: { quotationId } }" :step="model[2]" />
    </li>
    <li class="item">
      <step :to="quotationId == 'novo' ? '#' : { name: 'admin-quotation-project', params: { quotationId } }" :step="model[3]" />
    </li>
    <li class="item">
      <step :to="quotationId == 'novo' ? '#' : { name: 'admin-quotation-deal', params: { quotationId } }" :step="model[4]" />
    </li>
    <li class="item">
      <step :to="quotationId == 'novo' ? '#' : { name: 'admin-quotation-installation', params: { quotationId } }" :step="model[5]" />
    </li>
    <li class="item">
      <step :to="quotationId == 'novo' ? '#' : { name: 'admin-quotation-file', params: { quotationId } }" :step="model[6]" />
    </li>
    <li class="item">
      <step :to="quotationId == 'novo' ? '#' : { name: 'admin-quotation-approved', params: { quotationId } }"  :step="model[7]" :last="true"/>
    </li>
  </ul>
</template>

<script>
import Step from './Step.vue';

const STEPS = [
  {
    step: 1,
    label: 'Informações do cliente',
    completed: false,
  },
  {
    step: 2,
    label: 'Informações do serviço',
    completed: false,
  },
  {
    step: 3,
    label: 'Informações do orçamento',
    completed: false,
  },
  {
    step: 4,
    label: 'Informações da obra',
    completed: false,
  },
  {
    step: 5,
    label: 'Informações da negociação',
    completed: false,
  },
  {
    step: 6,
    label: 'Informações da instalação',
    completed: false,
  },
  {
    step: 7,
    label: 'Fotos (opcional)',
    completed: false,
  },
  {
    step: 8,
    label: 'Gol',
    completed: false,
  },
];

export default {
  name: 'Steps-quotation',
  props: {
    steps: {
      type: [Object, String],
      default: null,
    },
    quotationId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    model() {
      return this.steps !== null ? Object.values(this.steps) : STEPS;
    },
  },
  components: {
    Step,
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="scss" scoped>
.progress-steps {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: .7fr repeat(6, 1fr) .7fr;
  margin-bottom: 30px;
  .item {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
  }
}
</style>
